import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Merge a base `sx` with a caller-supplied one. Later entries win, so the
 * caller's `slotProps` styles override the component defaults.
 */
export function mergeSx(base: SxProps<Theme>, sx?: SxProps<Theme>): SxProps<Theme> {
  const toArray = (value?: SxProps<Theme>) => (Array.isArray(value) ? value : value ? [value] : []);

  return [...toArray(base), ...toArray(sx)];
}
